import { personalPath } from '../../constants';
import { urlService } from '../urlService';

export const getRedirectLMSHref = (courseUuid: string): string =>
  urlService.normalizeUrl(`${personalPath.gotolms}?courseId=${courseUuid}`);
